import { useState } from "react";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import logo from "../Assets/photo_2024-04-05_00-21-32-removebg-preview.png";

const Navbar = () => {
  const [menuIcon, setMenuIcon] = useState(false);

  return (
    <div className="bg-transparent  md:ml-3   text-center z-30    py-2 md:py-3 flex justify-between items-center">
      <div className="ml-2 w-6  text-white">
        <Link to="/">
          <img src={logo} alt="Imam Hosen" className=" " />
        </Link>
      </div>
      <div
        onClick={() => setMenuIcon(!menuIcon)}
        className={`absolute right-0 mr-1 md:m-3  cursor-pointer md:hidden ${
          menuIcon
            ? "after:border-2 after:border-[#009e66] after:w-4/5 after:h-4/5 after:animate-ping after:ease-out after:absolute after:rounded-full after:right-1 after:top-1"
            : ""
        }`}
      >
        {menuIcon ? (
          <CloseIcon
            className="glow-icon"
            sx={{ color: "#009e66", fontSize: "40px" }}
          />
        ) : (
          <MenuIcon
            className="glow-icon"
            sx={{ color: "#009e66", fontSize: "40px" }}
          />
        )}
      </div>

      <ul
        className={`text-white absolute right-0  mr-1 md:mr-3   md:flex  md:item-center   max-md:bg-[#191919] md:z-auto z-[-1] w-screen md:w-auto md:pl-0  transition-all duration-500 ease-in ${
          menuIcon ? "top-20 opacity-100" : "hidden"
        }  md:opacity-100`}
      >
        <li className="py-6 max-md:py-2   px-3   ">
          <Link
            to="/about"
            className="hover:text-[#009e66] font-bold after:mt-1 after:content-[''] after:block after:h-1 after:w-full after:bg-[#009e66] after:scale-x-0 after:origin-left after:transition-transform after:delay-200 after:ease-linear hover:after:scale-x-100"
          >
            About
          </Link>
        </li>
        <li className="py-6 px-3 max-md:py-2   ">
          <Link
            to="/resume"
            className="hover:text-[#009e66]  font-bold  after:mt-1 after:content-[''] after:block after:h-1 after:w-full after:bg-[#009e66] after:scale-x-0 after:origin-left after:transition-transform after:delay-200 after:ease-linear hover:after:scale-x-100  "
          >
            Resume
          </Link>
        </li>
        <li className="py-6  px-3  max-md:py-2  ">
          <Link
            to="/projects"
            className="hover:text-[#009e66]  font-bold after:mt-1 after:content-[''] after:block after:h-1 after:w-full after:bg-[#009e66] after:scale-x-0 after:origin-left after:transition-transform after:delay-200 after:ease-linear hover:after:scale-x-100 "
          >
            Projects
          </Link>
        </li>
        <li className="py-6  px-3   md:hidden max-md:py-2  ">
          <Link
            to="https://linktr.ee/mdimamhosen"
            className="hover:text-[#009e66]  font-bold after:mt-1 after:content-[''] after:block after:h-1 after:w-full after:bg-[#009e66] after:scale-x-0 after:origin-left after:transition-transform after:delay-200 after:ease-linear hover:after:scale-x-100 "
          >
            Links
          </Link>
        </li>
        <li className="py-6 max-md:py-2  px-3   ">
          <Link
            to="/contact"
            className="hover:text-[#009e66]  font-bold after:mt-1 after:content-[''] after:block after:h-1 after:w-full after:bg-[#009e66] after:scale-x-0 after:origin-left after:transition-transform after:delay-200 after:ease-linear hover:after:scale-x-100  "
          >
            Hire Me
          </Link>
        </li>
      </ul>
    </div>
  );
};
export default Navbar;
